var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { css, StyleSheet } from 'aphrodite';
import { bind } from 'bind-decorator';
import { observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Colors, MediaBreakPointUp } from '../styles';
import { LessonComponent } from '../molecules/lesson_component';
import { Button } from '../atoms';
import { LessonCompleteAnimationIcon } from '../atoms/lesson_complete_icon';
export var LessonResultSectionState;
(function (LessonResultSectionState) {
    LessonResultSectionState[LessonResultSectionState["Loading"] = 0] = "Loading";
    LessonResultSectionState[LessonResultSectionState["Ready"] = 1] = "Ready";
    LessonResultSectionState[LessonResultSectionState["Finished"] = 2] = "Finished";
})(LessonResultSectionState || (LessonResultSectionState = {}));
const State = LessonResultSectionState;
export const LessonResultSectionComponent = ({ vm, onClickExit, addFavoriteLesson, unFavoriteLesson, }) => {
    const [showAnimation, setShowAnimation] = React.useState(true);
    const onFinishAnimation = () => {
        setShowAnimation(false);
        if (vm.afterAnimationFinished) {
            vm.afterAnimationFinished();
        }
        else if (vm.startCountdown) {
            vm.beginCountdown();
        }
        else {
            vm.finishLessonResultSection();
        }
    };
    if (!vm.isVisible) {
        return null;
    }
    return (React.createElement("div", { className: css(styles.container) },
        vm.startCountdown && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: css(styles.header) },
                React.createElement("div", { className: css(styles.iconContainer), onClick: onClickExit, "data-test": "exitButton" },
                    React.createElement("img", { src: "/assets/images/video/back.svg", className: css(styles.icon) })),
                React.createElement("div", { className: css(styles.playText) },
                    vm.nextLessonStartTimerCount,
                    "\u79D2\u5F8C\u306B\u6B21\u306E\u52D5\u753B\u3092\u518D\u751F")),
            React.createElement(LessonComponent, { lesson: vm.videoVM.nextLesson, addFavoriteLesson: addFavoriteLesson, unFavoriteLesson: unFavoriteLesson, onClick: vm.playNextVideo, isVertical: true, isMin: true, isWhiteColor: true, classObject: styles.lessonContainer }),
            React.createElement("div", { className: css(styles.buttonContainer) },
                React.createElement(Button, { className: css(styles.button, styles.cancel), onClick: vm.onClickCancel, isRadius: true }, "\u30AD\u30E3\u30F3\u30BB\u30EB"),
                React.createElement(Button, { className: css(styles.button, styles.play), onClick: vm.onClickPlay, isRadius: true }, "\u4ECA\u3059\u3050\u518D\u751F")))),
        showAnimation && (React.createElement(LessonCompleteAnimationIcon, { classObject: styles.completeAnimation, onFinish: onFinishAnimation }))));
};
export const LessonResultSection = observer(LessonResultSectionComponent);
export class LessonResultSectionVM {
    constructor(playNextVideo) {
        // 自動再生のタイマーを管理
        Object.defineProperty(this, "timerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // ストリークオーバーレイ等でカウントダウンを一時停止中かどうか
        Object.defineProperty(this, "isCountdownSuspended", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        // 自動再生までの時間
        Object.defineProperty(this, "nextLessonStartTimerCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "player", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "videoVM", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // 動画の視聴完了UIのステータス
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: LessonResultSectionState.Loading
        });
        // 動画の視聴完了UIの表示制御
        Object.defineProperty(this, "isVisible", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        // 次の動画の自動再生を制御する
        Object.defineProperty(this, "isAutoPlay", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        // 次の動画のカウントダウンを制御する
        Object.defineProperty(this, "startCountdown", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        // 次に再生する動画
        Object.defineProperty(this, "nextLesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "watchingTimeSecond", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "unMounted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "afterAnimationFinished", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "playNextVideo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this, {
            nextLessonStartTimerCount: observable,
            player: observable,
            videoVM: observable,
            state: observable,
            isVisible: observable,
            isAutoPlay: observable,
            startCountdown: observable,
            nextLesson: observable,
            watchingTimeSecond: observable,
        });
        this.playNextVideo = playNextVideo;
    }
    onUnMount() {
        this.clearHideTimer();
        this.unMounted = true;
    }
    finishLessonResultSection() {
        this.isVisible = false;
        this.clearHideTimer();
        this.finish();
        this.showVideoPlayer();
    }
    initialize(videoVM) {
        return __awaiter(this, void 0, void 0, function* () {
            this.videoVM = videoVM;
            this.ready();
        });
    }
    setState(state) {
        this.state = state;
    }
    setAfterAnimationFinished(afterAnimationFinished) {
        this.afterAnimationFinished = afterAnimationFinished;
    }
    setVideoRefs(player) {
        this.player = player;
    }
    setNextLesson(nextLesson) {
        this.nextLesson = nextLesson;
    }
    setIsAutoPlay(isAutoPlay) {
        this.isAutoPlay = isAutoPlay;
    }
    onClickCancel() {
        return __awaiter(this, void 0, void 0, function* () {
            this.clearHideTimer();
            this.isVisible = false;
            yield this.showVideoPlayer();
        });
    }
    // 動画の視聴完了時に実行
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            // HACK: 視聴完了した動画が背景に残ってしまう場合があるためCSSで非表示にしています。。
            yield this.hideVideoPlayer();
            this.isVisible = true;
            if (this.isAutoPlay && this.nextLesson) {
                this.startAutoPlaySection();
            }
        });
    }
    onClickPlay() {
        this.clearHideTimer();
        this.playNextVideo();
    }
    ready() {
        this.setState(State.Ready);
    }
    finish() {
        this.setState(State.Finished);
    }
    // HACK: 動画プレイヤーを非表示にする
    hideVideoPlayer() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.videoVM.addClass('hideVideoPlayer');
            this.videoVM.hideController();
        });
    }
    // HACK: 動画プレイヤーを表示する
    showVideoPlayer() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.videoVM.removeClass('hideVideoPlayer');
            this.videoVM.showController();
        });
    }
    clearHideTimer() {
        if (this.timerId) {
            clearInterval(this.timerId);
            this.timerId = undefined;
        }
    }
    /**
     * 完了アニメーション終了後に呼ばれ、カウントダウンのタイマーを開始する。
     * ストリークオーバーレイ等で一時停止中の場合は開始しない。
     */
    beginCountdown() {
        if (!this.isCountdownSuspended) {
            this.nextLessonStartTimer();
        }
    }
    /**
     * ストリークオーバーレイ表示時にカウントダウンを一時停止する。
     */
    suspendCountdown() {
        this.clearHideTimer();
        this.isCountdownSuspended = true;
    }
    /**
     * ストリークオーバーレイ等で一時停止した後、自動再生のカウントダウンを10秒から再開する。
     */
    restartAutoPlayTimer() {
        this.isCountdownSuspended = false;
        if (this.isAutoPlay && this.nextLesson && this.startCountdown) {
            this.nextLessonStartTimerCount = 10;
            this.nextLessonStartTimer();
        }
    }
    /*---------- private methods  ----------*/
    // 次の動画を再生するUIを表示してカウントダウンの準備をする（タイマーは beginCountdown で開始）
    startAutoPlaySection() {
        this.setState(State.Finished);
        this.startCountdown = true;
        this.nextLessonStartTimerCount = 10;
    }
    // 指定時間の経過後に次の動画を再生する
    nextLessonStartTimer() {
        this.clearHideTimer(); // nextLessonStartTimer()が複数回実行された場合、過去のsetInterval()は消す
        this.timerId = window.setInterval(() => {
            if (--this.nextLessonStartTimerCount < 0) {
                this.clearHideTimer();
                this.playNextVideo();
            }
        }, 1000);
    }
}
__decorate([
    bind
], LessonResultSectionVM.prototype, "finishLessonResultSection", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "initialize", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "setState", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "setAfterAnimationFinished", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "setVideoRefs", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "setNextLesson", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "setIsAutoPlay", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "onClickCancel", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "start", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "onClickPlay", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "ready", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "finish", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "hideVideoPlayer", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "showVideoPlayer", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "clearHideTimer", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "beginCountdown", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "suspendCountdown", null);
__decorate([
    bind
], LessonResultSectionVM.prototype, "restartAutoPlayTimer", null);
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        display: 'flex',
        flexFlow: 'column',
        justifyContent: 'center',
        gap: 14,
        left: 0,
        position: 'absolute',
        top: 0,
        zIndex: 8,
        width: '100%',
        height: '100%',
        padding: '16px 24px',
        overflow: 'hidden',
    },
    header: {
        textAlign: 'center',
    },
    iconContainer: {
        position: 'absolute',
        top: 14,
        left: 16,
        cursor: 'pointer',
        display: 'inline-block',
        textAlign: 'center',
        transition: 'opacity 0.2s',
        ':hover': {
            opacity: 0.8,
        },
        [MediaBreakPointUp.MD]: {
            left: 24,
        },
    },
    icon: {
        width: 24,
    },
    playText: {
        fontSize: 12,
        fontWeight: 'bold',
        letterSpacing: '4%',
        lineHeight: '160%',
        [MediaBreakPointUp.MD]: {
            fontSize: 14,
            marginTop: 64,
        },
    },
    lessonContainer: {
        [MediaBreakPointUp.MD]: {
            width: 327,
        },
    },
    buttonContainer: {
        display: 'flex',
        width: '100%',
        gap: 7,
        [MediaBreakPointUp.MD]: {
            width: 327,
            marginBottom: 64,
        },
    },
    button: {
        width: '50%',
        height: 36,
        padding: 8,
    },
    cancel: {
        backgroundColor: Colors.GrayDarkestB,
    },
    play: {
        backgroundColor: Colors.PrimaryDark,
    },
    completeAnimation: {
        position: 'absolute',
        right: 0,
        left: 0,
        background: 'rgba(0, 0, 0, 0.50)',
        height: '165%',
    },
});
